import { Button } from '@accure/ui';
import { addDays } from 'date-fns';

import { useNow } from '@/hooks/useNow';

import type { DateRange } from './types';

type PresetButtonsProps = {
  onSelect: (value: DateRange) => void;
};

export function PresetButtons({ onSelect }: PresetButtonsProps) {
  const now = useNow();

  function setLastDays(days: number) {
    onSelect({ from: addDays(now, -days), to: now });
  }

  return (
    <div className="flex items-center gap-1 pb-[2px]">
      <Button
        size="sm"
        variant="ghost"
        data-testid="time-preset-24h"
        onClick={() => setLastDays(1)}
      >
        24h
      </Button>
      <Button
        size="sm"
        variant="ghost"
        data-testid="time-preset-7d"
        onClick={() => setLastDays(7)}
      >
        7d
      </Button>
      <Button
        size="sm"
        variant="ghost"
        data-testid="time-preset-30d"
        onClick={() => setLastDays(30)}
      >
        30d
      </Button>
    </div>
  );
}
